let agent:
  | { noticeError(error: Error | string, customAttributes?: object): unknown }
  | undefined;

export const initBrowserAgent = () => {
  const licenseKey = import.meta.env.VITE_NEW_RELIC_LICENSE_KEY;
  const applicationID = import.meta.env.VITE_NEW_RELIC_APPLICATION_ID;
  const accountID = import.meta.env.VITE_NEW_RELIC_ACCOUNT_ID;

  if (!licenseKey || !applicationID) return;

  import("@newrelic/browser-agent/loaders/browser-agent").then(
    ({ BrowserAgent }) => {
      agent = new BrowserAgent({
        info: {
          applicationID,
          beacon: "bam.nr-data.net",
          errorBeacon: "bam.nr-data.net",
          licenseKey,
          sa: 1,
        },
        init: {
          ajax: { deny_list: ["bam.nr-data.net"] },
          browser_consent_mode: { enabled: false },
          distributed_tracing: { enabled: true },
          // capture_measures stays off: React 19.2 emits a performance.measure
          // per component render (zero-width-space-prefixed names), so the
          // agent would ship a BrowserPerformance event for every render.
          performance: {
            capture_detail: false,
            capture_marks: false,
            capture_measures: false,
          },
          privacy: { cookies_enabled: true },
        },
        loader_config: {
          accountID,
          agentID: applicationID,
          applicationID,
          licenseKey,
          trustKey: accountID,
        },
      });
    },
  );
};

// No-op until the agent finishes its dynamic import (or if New Relic isn't
// configured for this env). Callers that need a guaranteed signal should use
// the isomorphic Honeybadger reporter (~/reporter) instead.
export const noticeError = (
  error: unknown,
  customAttributes?: object,
): void => {
  agent?.noticeError(
    error instanceof Error ? error : String(error),
    customAttributes,
  );
};
